import React, {useContext, useEffect, useRef, useState} from 'react';
import {Link} from "react-router-dom";
import {FaAngleDoubleRight} from "react-icons/fa";

function ApplicationMenu(props) {
    const [state,setState] = useState({position:'top'})
    console.log(props)
    useEffect(() => {
        //setState(prev=> {return {...prev,position: ''}})
        setState({position: ''})
    }, [])
    useEffect(() => {

            setState({position: props.opened === null ? 'top':''})


    }, [props.opened])
    return (
        <div className={`question-transition form-floating ${state.position}`}>
            <div className={`transitionable delay-3`}>
                <Link to={'/apply'} onClick={() => {
                    props.sidebar.close()
                }}>
                    <div className="form-control d-flex align-items-center py-3">
                            <span className="item-icon-circle ms-1 me-3 text-info bg-white"><FaAngleDoubleRight
                                size={20}/></span> Provide your information
                    </div>
                </Link>
            </div>
            <div className={`transitionable delay-4`}>
                <Link to={'/upload'} onClick={() => {
                    props.sidebar.close()
                }}>
                    <div className="form-control d-flex align-items-center py-3 mt-2">
                            <span className="item-icon-circle ms-1 me-3 text-info bg-white"><FaAngleDoubleRight
                                size={20}/></span> Upload your documentation
                    </div>
                </Link>
            </div>
            <div className={`transitionable delay-5`}>
                {/*<Link to={'/upload-1'}>*/}
                <div className="form-control d-flex align-items-center py-3 mt-2 text-dark">
                            <span className="item-icon-circle ms-1 me-3 bg-white text-mute"><FaAngleDoubleRight
                                size={20}/></span> Sign your application
                </div>
                {/*</Link>*/}
            </div>
        </div>
    );
}

export default ApplicationMenu;